import { React, useState, useEffect, useContext } from "react";
import "../../../assets/css/table.css";
import "../../../assets/css/dashboard.css";
import Loading from "react-fullscreen-loading";
import HeaderSection from "../banner/HeaderSection";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import axios from "axios";
import { toast } from "react-toastify";
import * as CONST from "../../../component/config/Constant";
import Form from "../../../component/utilities/Forms";
import { Modal, Button } from "react-bootstrap";
import { AuthContext } from "../../../component/context/AuthContext";
import Moment from "moment";
import { FiBox, FiClock, FiCheckCircle, FiXCircle, FiRotateCcw, FiThumbsUp } from "react-icons/fi";

function AssetsList() {
  const [authUserData] = useContext(AuthContext);
  const [fullLoading, setFullLoading] = useState(false);
  const [validate, setValidate] = useState({});
  const [assetsData, setAssetsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [disabled, setDisabled] = useState(false);
  const [stats, setStats] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [maxPageLimit, setMaxPageLimit] = useState(10);
  const [minPageLimit, setMinPageLimit] = useState(0);

  const [show, setShow] = useState(false);
  const [AssetsTypeData, setAssetsTypeData] = useState([]);
  const [assetsTypeId, setAssetsTypeId] = useState("");

  // Search
  const [searchAssetName, setSearchAssetName] = useState("");
  const [searchStatus, setSearchStatus] = useState("");

  const [dataSort, setDataSort] = useState({ order: "desc", order_by: "id" });

  let isToken = "";
  let userId = "";
  if (authUserData && authUserData[0]) {
    userId = authUserData[0].user_id || 0;
    isToken = authUserData[0].token || "";
  }

  const [searchParam, setSearchParam] = useState({
    srchAssetName: "",
    srchAssetStatus: "",
  });

  useEffect(() => {
    fetchAssetsType();
    fetchMyAssets(searchParam, dataSort, activePage, perPage);
  }, []);

  const fetchMyAssets = async (paramSearch, paramSort, paramPage, paramLimit) => {
    setLoading(true);
    try {
      const response = await axios.post(
        CONST.GET_ASSETS_LIST,
        {
          user_id: userId,
          limit: paramLimit,
          page_number: paramPage,
          search_input: paramSearch,
          sort: paramSort,
        },
        { headers: { Authorization: `Bearer ${isToken}` } }
      );
      if (response.data.status === "success") {
        setAssetsData(response.data.data || []);
        setTotalRows(response.data.count || 0);
        setTotalRecords(response.data.count || 0);
        if (response.data.stats) setStats(response.data.stats);
      } else {
        setAssetsData([]);
        setTotalRows(0);
        setTotalRecords(0);
      }
    } catch (error) {
      setAssetsData([]);
    }
    setLoading(false);
  };

  const fetchAssetsType = async () => {
    try {
      const response = await axios.get(CONST.ASSETS_TYPE_LIST, {
        headers: { Authorization: `Bearer ${isToken}` },
      });
      if (response.data.status === "success") setAssetsTypeData(response.data.data);
    } catch (error) {}
  };

  function assetSearch() {
    const params = { srchAssetName: searchAssetName, srchAssetStatus: searchStatus };
    setSearchParam(params);
    setActivePage(1);
    fetchMyAssets(params, dataSort, 1, perPage);
  }

  function clearSearch() {
    setSearchAssetName("");
    setSearchStatus("");
    const params = { srchAssetName: "", srchAssetStatus: "" };
    setSearchParam(params);
    setActivePage(1);
    fetchMyAssets(params, dataSort, 1, perPage);
  }

  const handlePageChange = async (page) => {
    setActivePage(parseInt(page));
    fetchMyAssets(searchParam, dataSort, parseInt(page), perPage);
  };

  const handleSort = async (column, sortDirection) => {
    setActivePage(1);
  };

  const handleClose = () => {
    setShow(false);
    setAssetsTypeId("");
    setValidate({});
  };

  const validateAsset = async () => {
    let isValid = true;
    let validator = Form.validator({
      assetsTypeId: { value: assetsTypeId, isRequired: true, label: "Asset Type" },
    });
    if (validator !== null) {
      setValidate({ validate: validator.errors });
      isValid = false;
    } else {
      setValidate({ validate: "" });
    }
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const valid = await validateAsset();
    if (valid) {
      setDisabled(true);
      try {
        const response = await axios.post(CONST.ADD_ASSETS, {
          asset_type_id: assetsTypeId,
          request_create_date: new Date(),
          quantity: "1",
        }, { headers: { Authorization: `Bearer ${isToken}` } });
        if (response.data.status === "error") {
          toast.error(response.data.message || "Something went wrong.");
        } else {
          toast.success("Asset request submitted successfully");
          fetchMyAssets(searchParam, dataSort, activePage, perPage);
          handleClose();
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again.");
      }
      setDisabled(false);
    }
  };

  const AssetStatus = ({ row }) => {
    const status = row.request_status;
    const getStatusBadge = () => {
      if (status == "0") return { className: "bg-warning text-dark", label: "New Request" };
      if (status == "1") return { className: "", label: "In Process", style: { backgroundColor: "#fff3cd", color: "#856404" } };
      if (status == "2") return { className: "", label: "Allocated", style: { backgroundColor: "#d4edda", color: "#155724" } };
      if (status == "3") return { className: "bg-danger", label: "Rejected" };
      if (status == "4") return { className: "", label: "Returned", style: { backgroundColor: "#e2e8f0", color: "#475569" } };
      if (status == "5") return { className: "", label: "Head Approved", style: { backgroundColor: "#dbeafe", color: "#1e40af" } };
      return { className: "bg-secondary", label: "Unknown" };
    };
    const badge = getStatusBadge();
    return (
      <span
        className={`badge rounded-pill ${badge.style ? "" : badge.className}`}
        style={badge.style || {}}
      >
        {badge.label}
      </span>
    );
  };

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => (activePage - 1) * perPage + index + 1,
      width: "8%",
    },
    {
      name: "Asset Type",
      selector: (row) => row.e_asset_type?.name || "",
      width: "20%",
    },
    {
      name: "Brand",
      selector: (row) => row.assetBrandDetails?.brand_name || row.asset_brand_name || "-",
      width: "15%",
    },
    {
      name: "Date",
      selector: (row) => row.request_create_date
        ? Moment(row.request_create_date).format("DD-MM-YYYY")
        : Moment(row.created_at).format("DD-MM-YYYY"),
      width: "15%",
    },
    {
      name: "Status",
      cell: (row) => <AssetStatus row={row} />,
      width: "15%",
    },
    {
      name: "Processed By",
      cell: (row) => {
        if (row.allocatedByData) return row.allocatedByData.first_name + " " + row.allocatedByData.last_name;
        if (row.request_status === "5" && row.headApprovedByData) return "Head: " + row.headApprovedByData.first_name;
        return "-";
      },
      width: "15%",
    },
  ];

  const StatCard = ({ icon, label, value, bgColor, color }) => (
    <div className="col-6 col-md-2">
      <div className="db-stat-card">
        <div className="db-stat-icon" style={{ background: bgColor, color: color }}>{icon}</div>
        <div className="db-stat-value">{value}</div>
        <div className="db-stat-label">{label}</div>
      </div>
    </div>
  );

  /* PAGINATION - same as leaves page */
  function toPages(pages) {
    const results = [];
    for (let i = 1; i <= pages; i++) results.push(i);
    return results;
  }
  function getNumberOfPages(rowCount, rowsPerPage) {
    return Math.ceil(rowCount / rowsPerPage);
  }

  const BootyPagination = ({ rowsPerPage, rowCount, onChangePage, currentPage }) => {
    const handleBackButtonClick = async () => {
      if ((currentPage - 1) % perPage === 0) {
        setMaxPageLimit(maxPageLimit - perPage);
        setMinPageLimit(minPageLimit - perPage);
      }
      onChangePage(currentPage - 1);
    };
    const handleNextButtonClick = async () => {
      if (currentPage + 1 > maxPageLimit) {
        setMaxPageLimit(maxPageLimit + perPage);
        setMinPageLimit(minPageLimit + perPage);
      }
      onChangePage(currentPage + 1);
    };
    const handlePageNumber = (e) => onChangePage(Number(e.target.value));

    let paginationText = "Page: " + currentPage + ", Showing ";
    paginationText += ((currentPage - 1) * perPage + 1) + " to " + perPage * currentPage;
    paginationText += " of " + rowCount + " entries;";

    const pages = getNumberOfPages(rowCount, rowsPerPage);
    const pageItems = toPages(pages);
    const nextDisabled = currentPage === pageItems.length;
    const previosDisabled = currentPage === 1;

    const pageNumbers = pageItems.map((page) => {
      if (page <= maxPageLimit && page > minPageLimit) {
        return (
          <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
            <button className={`page-link ${currentPage === page ? "active" : ""}`} onClick={handlePageNumber} value={page}>{page}</button>
          </li>
        );
      }
      return null;
    });

    let pageIncrementEllipses = null;
    if (pageItems.length > maxPageLimit) {
      pageIncrementEllipses = <li className="page-item" onClick={handleNextButtonClick}>&hellip;</li>;
    }
    let pageDecremenEllipses = null;
    if (minPageLimit >= 1) {
      pageDecremenEllipses = <li className="page-item" onClick={handleBackButtonClick}>&hellip;</li>;
    }

    return (
      <div className="card-footer d-flex align-items-center">
        <p className="m-0 text-muted">{paginationText}</p>
        <ul className="pagination m-0 ms-auto">
          <li className="page-item">
            <button className="page-link" onClick={handleBackButtonClick} disabled={previosDisabled}>«</button>
          </li>
          {pageDecremenEllipses}
          {pageNumbers}
          {pageIncrementEllipses}
          <li className="page-item">
            <button className="page-link" onClick={handleNextButtonClick} disabled={nextDisabled}>»</button>
          </li>
        </ul>
      </div>
    );
  };

  const CustomLoader = () => (
    <div style={{ padding: "24px" }}><DivLoader color="primary" /></div>
  );

  return (
    <>
      <Loading loading={fullLoading} background="rgba(0,0,0,0.5)" loaderColor="#fff" />
      <HeaderSection
        title="My"
        heading="Assets"
        addButton={() => setShow(true)}
        addLink="#"
        addLinkName="Request Asset"
        linktype="add"
      />

      {/* Stats Cards */}
      {stats && (
        <div className="container-xl mt-3">
          <div className="row db-stats-row">
            <StatCard icon={<FiBox size={18} />} label="Total Requests" value={stats.total} bgColor="#e8f0fe" color="#1167e8" />
            <StatCard icon={<FiClock size={18} />} label="Pending" value={stats.pending} bgColor="#fef3c7" color="#b45309" />
            <StatCard icon={<FiThumbsUp size={18} />} label="Head Approved" value={stats.headApproved} bgColor="#dbeafe" color="#1167e8" />
            <StatCard icon={<FiCheckCircle size={18} />} label="Allocated" value={stats.allocated} bgColor="#d1fae5" color="#059669" />
            <StatCard icon={<FiXCircle size={18} />} label="Rejected" value={stats.rejected} bgColor="#fee2e2" color="#dc2626" />
            <StatCard icon={<FiRotateCcw size={18} />} label="Returned" value={stats.returned} bgColor="#f1f5f9" color="#6b7280" />
          </div>
        </div>
      )}

      <div className="page-body">
        <div className="container-xl">
          <div className="row row-cards">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Listing</h3>
                </div>
                <div className="card-body border-bottom py-3">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label className="form-label">Asset Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search asset..."
                          value={searchAssetName}
                          onChange={(e) => setSearchAssetName(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group mb-3">
                        <label className="form-label">Status</label>
                        <select
                          className="form-select form-control"
                          value={searchStatus}
                          onChange={(e) => setSearchStatus(e.target.value)}
                        >
                          <option value="">All</option>
                          <option value="0">New Request</option>
                          <option value="5">Head Approved</option>
                          <option value="1">In Process</option>
                          <option value="2">Allocated</option>
                          <option value="3">Rejected</option>
                          <option value="4">Returned</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-3">
                        <label className="form-label">&nbsp;</label>
                        <div>
                          <button
                            type="button"
                            name="btnSearch"
                            id="btnSearch"
                            className="btn btn-blue d-none d-sm-inline-block mr-3"
                            onClick={assetSearch}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                              <circle cx="10" cy="10" r="7"></circle>
                              <line x1="21" y1="21" x2="15" y2="15"></line>
                            </svg>
                            Search
                          </button>
                          &nbsp;
                          <button
                            type="button"
                            name="btnReset"
                            id="btnReset"
                            className="btn btn-outline-primary mr-3"
                            onClick={clearSearch}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                              <line x1="18" y1="6" x2="6" y2="18"></line>
                              <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={assetsData}
                    progressPending={loading}
                    progressComponent={<CustomLoader />}
                    pagination="true"
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    paginationPerPage={perPage}
                    paginationComponent={BootyPagination}
                    sortServer
                    onSort={handleSort}
                  />
                </div>
                <div className="card-footer d-flex align-items-center">
                  <p className="m-0 text-muted">
                    Showing <span>{totalRecords}</span> entries
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Request Asset Modal */}
      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Request Asset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group mb-3">
                  <label className="form-label required">Asset Type</label>
                  <select
                    className={`form-select form-control ${validate.validate && validate.validate.assetsTypeId ? "is-invalid" : ""}`}
                    value={assetsTypeId}
                    onChange={(e) => setAssetsTypeId(e.target.value)}
                  >
                    <option value="">Select Asset Type</option>
                    {AssetsTypeData.map((item, i) => (
                      <option value={item.id} key={i}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={handleSubmit} disabled={disabled}>
            {disabled ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AssetsList;
